export const headersList = [
  {
    text: "ID",
    value: "id",
  },
  {
    text: "Nombre Cliente",
    value: "nombre_completo",
  },
  {
    text: "Correo",
    value: "correo",
  },
  {
    text: "Telefono",
    value: "telefonoMovil",
  },
  {
    text: "RFC",
    value: "rfc",
  },
  {
    text: "Fecha nacimiento",
    value: "fechaNacimiento",
  },
  {
    text: "Ver",
    value: "ver",
  },
];
